import PropTypes from 'prop-types';

import LayoutBrochure from '../../components/LayoutBrochure';
import LinkTile from '../../components/LinkTile';
import PageTitle from '../../components/PageTitle';
import { ErrorSpace } from '../../contexts/errorCaptureContext';
import { asyncRequestStates } from '../../hooks/useAsyncRequest';
import useGlobalContent from '../../hooks/useGlobalContent';
import useHomePageContent from './hooks/useHomePageContent';
import useStyles from './home.styles';
import HomeFullBleed from './HomeFullBleed';
import HomeMissionSelect from './HomeMissionSelect';
import HomeStats from './HomeStats';
import HomeVideo from './HomeVideo';

const Home = ({ title }) => {
  const {
    content: { missions },
    contentState,
  } = useGlobalContent();
  const {
    pageContent: {
      header,
      missions: homeMissions,
      fullBleed,
      caption,
      downloadPosters,
    },
    pageContentState,
  } = useHomePageContent();
  const styles = useStyles();

  return (
    <LayoutBrochure absHeader>
      <ErrorSpace space="/">
        <PageTitle title={title} />
        {pageContentState === asyncRequestStates.SUCCESS &&
          contentState === asyncRequestStates.SUCCESS && (
            <>
              <HomeVideo
                body={header.body}
                cta={header.playCta}
                loopVideo={header.loopVideo}
                video={header.video}
              />
              <HomeMissionSelect
                missions={missions}
                title={homeMissions.title}
              />
              <HomeStats />
              <HomeFullBleed content={fullBleed} />
              {downloadPosters && (
                <div className={styles.downloadPosters}>
                  <LinkTile
                    body={downloadPosters?.body}
                    imgSrc={downloadPosters?.imgSrc}
                    download={downloadPosters?.download}
                    size="lg"
                    title={downloadPosters?.title}
                  />
                </div>
              )}
            </>
          )}
      </ErrorSpace>
    </LayoutBrochure>
  );
};

Home.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
};

export default Home;
